import {MY_TEAM_ISACTIVE,MY_TEAM_ISACTIVE_SUCCESS,MY_TEAM_ISACTIVE_FAILED,ALL_MY_TEAM_GET_USERS, MY_TEAM_GET_USERS, MY_TEAM_GET_USERS_SUCCESSFULL,MY_TEAM_GET_USERS_FAILED, MY_TEAM_DELETE_USER, MY_TEAM_DELETE_USER_SUCCESSFULL, MY_TEAM_DELETE_USER_FAILED, MY_TEAM_RESEND_VERIFICATION_EMAIL, MY_TEAM_RESEND_VERIFICATION_EMAIL_SUCCESS, MY_TEAM_RESEND_VERIFICATION_EMAIL_FAILED, GET_SAMPLE_CSV_USERS, GET_SAMPLE_CSV_USERS_SUCCESS, GET_SAMPLE_CSV_USERS_FAILED, POST_CSV_USERS, POST_CSV_USERS_SUCCESS, POST_CSV_USERS_FAILED } from "./actionTypes";

export const getUsersMyTeam = (customJSON) => {
    return {
        type: MY_TEAM_GET_USERS,
        payload:{customJSON}
        
    }
}

export const getUsersMyTeamSuccessful = (usersMyTeam) => {
    return {
        type: MY_TEAM_GET_USERS_SUCCESSFULL,
        payload: {usersMyTeam}
    }
}

export const getUsersMyTeamFailed = (message) => {
    return {
        type: MY_TEAM_GET_USERS_FAILED,
        payload: {message}
    }
}
export const deleteUser = (userId) => {
    return {
        type: MY_TEAM_DELETE_USER,
        payload: {userId}
    }
}

export const deleteUserSuccessful = (message) => {
    return {
        type: MY_TEAM_DELETE_USER_SUCCESSFULL,
        payload: {message}
    }
}

export const deleteUserFailed = (message) => {
    return {
        type: MY_TEAM_DELETE_USER_FAILED,
        payload: {message}
    }
}

export const getAllUsersMyTeam = (customJSON) => {
    return {
        type: ALL_MY_TEAM_GET_USERS,
        payload:{customJSON}
        
    }
}

export const isActive = (data) => {
    return {
        type: MY_TEAM_ISACTIVE,
        payload: {data}
    }
}

export const isActiveFailed = (message) => {
    return {
        type: MY_TEAM_ISACTIVE_FAILED,
        payload: {message}
    }
}

export const isActiveSuccess = (customJSON) => {
    return {
        type: MY_TEAM_ISACTIVE_SUCCESS,
        payload:{customJSON}
        
    }
}

export const resendVerificationEmail = (data) => {
    return {
        type: MY_TEAM_RESEND_VERIFICATION_EMAIL,
        payload: {data}
    }
}

export const resendVerificationFailed = (message) => {
    return {
        type: MY_TEAM_RESEND_VERIFICATION_EMAIL_FAILED,
        payload: {message}
    }
}

export const resendVerificationEmailSuccess = (customJSON) => {
    return {
        type: MY_TEAM_RESEND_VERIFICATION_EMAIL_SUCCESS,
        payload:{customJSON}
        
    }
}

export const getSampleCsvUsers = () => {
    return {
        type: GET_SAMPLE_CSV_USERS,
    }
}

export const getSampleCsvUsersSuccess = (data) => {
    return {
        type: GET_SAMPLE_CSV_USERS_SUCCESS,
        payload:data
    }
}

export const getSampleCsvUsersFailed = (data) => {
    return {
        type: GET_SAMPLE_CSV_USERS_FAILED,
        payload:data
    }
}

export const postCsvUsers = (data) => {
    return {
        type: POST_CSV_USERS,
        payload:data
    }
}

export const postCsvUsersSuccess = (data) => {
    return {
        type: POST_CSV_USERS_SUCCESS,
        payload:data
    }
}

export const postCsvUsersFailed = (data) => {
    return {
        type: POST_CSV_USERS_FAILED,
        payload:data
    }
}

